import { Logo } from "./Logo";

const DEFAULTS = {
  address: "16 Woodridge Ct\nNewton, NJ 07860",
  email: "werkhausautomotive.nj@gmail.com",
  hours: "08:00 – 20:00",
  blurb: "Precision German engineering & service. Diagnostics, tuning, maintenance and curated performance vehicle sales.",
  coords: "41.0581° N /// 74.7527° W",
  tagline: "Built like a gearbox. No play.",
};

export default function Footer({ content }) {
  const address = content?.footer_address || DEFAULTS.address;
  const email = content?.footer_email || DEFAULTS.email;
  const phone = content?.footer_phone || "";
  const hours = content?.footer_hours || DEFAULTS.hours;
  const blurb = content?.footer_blurb || DEFAULTS.blurb;
  const coords = content?.footer_coords || DEFAULTS.coords;
  const tagline = content?.footer_tagline || DEFAULTS.tagline;

  return (
    <footer className="border-t border-[#263342]" data-testid="footer">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16 grid md:grid-cols-4 gap-12">
        <div className="md:col-span-2">
          <div className="flex items-center gap-3">
            <Logo size={36} />
            <span className="font-display font-bold text-2xl tracking-[0.18em] uppercase text-slate-100">Werkhaus</span>
          </div>
          <p className="mt-5 text-sm text-slate-400 leading-relaxed max-w-sm" data-testid="footer-blurb">{blurb}</p>
          <p className="mt-6 font-mono text-[10px] uppercase tracking-[0.3em] text-slate-600" data-testid="footer-coords">{coords}</p>
        </div>
        <div>
          <p className="font-mono text-xs uppercase tracking-[0.3em] text-crimson font-semibold mb-5">Workshop</p>
          <ul className="space-y-3 text-sm text-slate-400">
            <li data-testid="footer-address">
              {address.split("\n").map((line, i) => (
                <span key={i}>{line}{i < address.split("\n").length - 1 && <br />}</span>
              ))}
            </li>
            <li data-testid="footer-email">{email}</li>
            {phone && (
              <li data-testid="footer-phone">
                <a href={`tel:${phone.replace(/[^+\d]/g, "")}`} className="hover:text-slate-200 transition-colors">{phone}</a>
              </li>
            )}
          </ul>
        </div>
        <div>
          <p className="font-mono text-xs uppercase tracking-[0.3em] text-crimson font-semibold mb-5">Hours</p>
          <ul className="space-y-3 text-sm text-slate-400">
            <li className="flex justify-between gap-6"><span>Open Daily</span><span className="font-mono text-slate-300" data-testid="footer-hours">{hours}</span></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-[#263342]">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 py-6 flex flex-wrap items-center justify-between gap-4">
          <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-slate-600">
            © {new Date().getFullYear()} Werkhaus Automotive. All rights reserved.
          </p>
          <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-slate-600" data-testid="footer-tagline">{tagline}</p>
        </div>
      </div>
    </footer>
  );
}
